export class MQTTFeedbackError extends Error {
  variable: string;

  constructor(message: string, variable: string) {
    super(message);
    this.variable = variable;
  }
}
